<template>
  <div class="container-fluid cs-assistant">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <div class="header-title">
              <h4 class="card-title">{{ pageTitle }}</h4>
            </div>
          </div>
          <div class="card-body">
            <!-- 최신 파일 -->
            <h5 class="mb-2">最新版本下载 / 최신 파일 다운로드</h5>
            <div v-if="loading" class="text-muted mb-4">加载中…(불러오는 중)</div>
            <div v-else-if="error" class="alert alert-warning mb-4">{{ error }}</div>
            <div v-else-if="!info" class="alert alert-secondary mb-4">
              暂无可下载的文件，请联系管理员(아직 올라온 파일이 없습니다. 관리자에게 문의해 주세요)
            </div>
            <div v-else class="d-flex flex-wrap align-items-center mb-4">
              <a class="btn btn-primary mr-3 mb-2" :href="downloadUrl">下载 客服助手 v{{ info.version }}(다운로드)</a>
              <small class="text-muted mb-2">{{ info.file }} · {{ sizeText }} · 更新(갱신) {{ updatedText }}</small>
            </div>

            <!-- 안내 — 중국어/한국어를 한 줄에 섞으면 읽기 어렵다는 요청(10-04)으로 탭을 나눈다 -->
            <b-tabs v-model="langTab" content-class="mt-3">
              <b-tab title="中文说明">
                <h5 class="mb-2">安装方法</h5>
                <ol class="cs-assistant__steps mb-4">
                  <li>点击上方按钮下载 zip 文件，解压到一个<b>固定的文件夹</b>。<br><small class="text-muted">安装后此文件夹不能删除或移动，否则插件会失效。</small></li>
                  <li>在 Chrome 地址栏输入 <code>chrome://extensions</code> 打开扩展程序页面。</li>
                  <li>打开右上角的「开发者模式」。</li>
                  <li>点击「加载已解压的扩展程序」，选择刚才解压的文件夹。<br><small class="text-muted">选择里面直接有 manifest.json 的那一层文件夹。</small></li>
                  <li>如果已安装网上应用店的 COUPLUS 插件，请先停用它，避免两个同时运行。</li>
                </ol>

                <h5 class="mb-2">登录验证</h5>
                <ul class="mb-4">
                  <li>每个人用<b>自己的子账号</b>登录 <b>coupass.kr</b> 即可，不需要管理员账号。</li>
                  <li>在同一个 Chrome 中登录后直接使用，无需在插件里另外输入账号。</li>
                  <li>草稿的使用记录会按登录的子账号保存。</li>
                  <li>提示「请先登录」时，请重新登录 coupass.kr 后再点一次。</li>
                </ul>

                <h5 class="mb-2">使用方法</h5>
                <ol class="cs-assistant__steps mb-4">
                  <li>打开 Kakao 客服后台(business.kakao.com)的聊天室，页面上会出现「CS 助手」按钮。</li>
                  <li>点击按钮，会弹出一个独立的小窗口。窗口会跟随当前聊天室。</li>
                  <li>窗口会读取对话并生成几种回复草稿。选一个点「填入输入框」，修改后用 Kakao 原有的发送按钮发送。</li>
                  <li>都不合适时点「自己写」，可以用中文写要点，再点「转成韩语」。</li>
                  <li>需要查客户账号时，点「关联账号」，输入客户的注册邮箱发送验证码，客户告知验证码后填入确认。</li>
                  <li>插件不会自动发送消息，发送永远由人来操作。</li>
                </ol>

                <h5 class="mb-2">更新方法</h5>
                <ol class="cs-assistant__steps mb-0">
                  <li>下载新版本 zip，解压后<b>覆盖</b>原来的文件夹。</li>
                  <li>在 <code>chrome://extensions</code> 页面点该插件的刷新按钮 ⟳，然后刷新 Kakao 客服页面。</li>
                </ol>
              </b-tab>

              <b-tab title="한국어 안내">
                <h5 class="mb-2">설치 방법</h5>
                <ol class="cs-assistant__steps mb-4">
                  <li>위 버튼으로 zip 을 받아 <b>지우지 않을 폴더</b>에 압축을 풉니다.<br><small class="text-muted">설치 후 이 폴더를 지우거나 옮기면 확장이 동작하지 않습니다.</small></li>
                  <li>크롬 주소창에 <code>chrome://extensions</code> 를 입력합니다.</li>
                  <li>오른쪽 위 「개발자 모드」를 켭니다.</li>
                  <li>「압축해제된 확장 프로그램 로드」 → 방금 푼 폴더를 선택합니다.<br><small class="text-muted">manifest.json 이 바로 들어 있는 폴더를 고릅니다.</small></li>
                  <li>웹스토어 COUPLUS 확장이 깔려 있으면 먼저 꺼 둡니다(둘이 같이 돌지 않게).</li>
                </ol>

                <h5 class="mb-2">로그인 인증</h5>
                <ul class="mb-4">
                  <li>각자 <b>자기 子账号(직원 계정)</b>로 <b>coupass.kr</b> 에 로그인하면 됩니다. 관리자 계정은 필요 없습니다.</li>
                  <li>같은 크롬에서 로그인돼 있으면 확장에 따로 입력할 것이 없습니다.</li>
                  <li>초안 사용 기록은 로그인한 子账号 기준으로 남습니다.</li>
                  <li>「请先登录」가 뜨면 coupass.kr 에 다시 로그인하고 한 번 더 누르세요.</li>
                </ul>

                <h5 class="mb-2">사용 방법</h5>
                <ol class="cs-assistant__steps mb-4">
                  <li>카카오 상담 화면(business.kakao.com)에서 채팅방을 열면 「CS 助手」 버튼이 생깁니다.</li>
                  <li>버튼을 누르면 작은 별도 창이 뜨고, 지금 보는 채팅방을 따라갑니다.</li>
                  <li>대화를 읽고 답변 초안 몇 개를 만듭니다. 하나를 골라 「填入输入框」 → 고친 뒤 카카오 원래 전송 버튼으로 보냅니다.</li>
                  <li>셋 다 아니면 「自己写」 → 중국어로 요점만 쓰고 「转成韩语」를 누릅니다.</li>
                  <li>고객 계정 확인이 필요하면 「关联账号」 → 가입 이메일로 인증번호 발송 → 고객이 알려준 번호를 입력합니다.</li>
                  <li>확장은 메시지를 자동으로 보내지 않습니다. 전송은 항상 사람이 합니다.</li>
                </ol>

                <h5 class="mb-2">업데이트 방법</h5>
                <ol class="cs-assistant__steps mb-0">
                  <li>새 zip 을 받아 원래 폴더에 <b>덮어쓰기</b>로 풉니다.</li>
                  <li>확장 카드의 새로고침 ⟳ 을 누르고 카카오 상담 화면도 새로고침합니다.</li>
                </ol>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { coupassMenuTitle } from './coupassMenu';

// 客服助手(cs 빌드 확장) 배포본 안내 — 파일은 /api/cs/extension/* 가 CS 권한(관리자·쿠패스 子账号) 뒤에서 준다.
export default {
  name: 'CoupassCsAssistant',
  data() {
    return {
      pageTitle: coupassMenuTitle('logis.csassistant'),
      loading: true,
      error: '',
      info: null,
      langTab: 0,
      downloadUrl: '/api/cs/extension/download'
    };
  },
  computed: {
    sizeText() {
      if (!this.info || !this.info.size) return '';
      return (this.info.size / 1024 / 1024).toFixed(2) + ' MB';
    },
    updatedText() {
      if (!this.info || !this.info.updatedAt) return '';
      const d = new Date(this.info.updatedAt);
      return isNaN(d.getTime()) ? '' : d.toLocaleDateString();
    }
  },
  mounted() {
    this.loadInfo();
  },
  methods: {
    async loadInfo() {
      this.loading = true;
      this.error = '';
      try {
        const res = await axios.get('/api/cs/extension/info');
        this.info = res.data && res.data.ok ? res.data : null;
      } catch (e) {
        console.error('[客服助手] 파일 정보 조회 실패', e);
        const status = e.response && e.response.status;
        this.error = status === 401 || status === 403
          ? '没有权限，请用自己的子账号登录 coupass.kr(권한이 없습니다. 자기 子账号로 로그인해 주세요)'
          : '读取文件信息失败，请稍后再试(파일 정보를 읽지 못했습니다. 잠시 후 다시 시도해 주세요)';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.cs-assistant__steps li {
  margin-bottom: 6px;
}
</style>
